// frontend/src/services/statistics.js
import api from './api';

class StatisticsService {
    async getTodayStats() {
        try {
            console.log('Making API request to /statistics.php');
            const response = await api.get('/statistics.php');

            console.log('Full response object:', response);
            console.log('Response status:', response.status);
            console.log('Response headers:', response.headers);
            console.log('Response data:', response.data);
            console.log('Response data type:', typeof response.data);

            // Return the data property which contains the actual response
            return response.data;
        } catch (error) {
            console.error('Error in getTodayStats:', error);
            console.error('Error response:', error.response);
            console.error('Error message:', error.message);
            throw error;
        }
    }
}

export default new StatisticsService();